import React, { useState } from 'react';
import {
  UserOutlined,
  QuestionCircleOutlined,
  LogoutOutlined,
  MenuOutlined,
} from '@ant-design/icons';
import { Button, Menu, Popconfirm, Row, Tag, Drawer } from 'antd';
import type { MenuProps, PopconfirmProps } from 'antd';
import { NavLink, useNavigate } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { AppDispatch, RootState } from '../../../store/store';
import { TbHomeSearch } from "react-icons/tb";
import { FiUsers } from "react-icons/fi";
import { doLogout } from '../../../store/slices/authSlice';
import { deleteProjectsData } from '../../../store/slices/projectSlice';
import { deleteUsersData } from '../../../store/slices/userSlice';
import toast from 'react-hot-toast';
import { useMediaQuery } from 'react-responsive';
import { BiBuildings } from "react-icons/bi";
import { LuLayoutDashboard } from "react-icons/lu";
import { CgFileAdd } from "react-icons/cg";
import { FaRegListAlt } from "react-icons/fa";
import { MdOutlineAssignmentInd } from "react-icons/md";
import { VscDebugStart } from "react-icons/vsc";

import * as S from "./Menu.styles"

type MenuItem = Required<MenuProps>['items'][number];

const NavMenu: React.FC = () => {
  const [current, setCurrent] = useState('accueil');
  const [drawerVisible, setDrawerVisible] = useState(false);
  const { user } = useSelector((state: RootState) => state.auth);
  const dispatch = useDispatch<AppDispatch>();
  const navigate = useNavigate();
  const isMobile = useMediaQuery({ maxWidth: 900 });

  const onClick: MenuProps['onClick'] = (e) => {
    console.log('click ', e);
    setCurrent(e.key);
    setDrawerVisible(false);
  };

  const handleLogout = () => {
    dispatch(doLogout());
    dispatch(deleteProjectsData());
    dispatch(deleteUsersData());
    navigate("/login");
    toast.success(`Déconnecté(e)`);
  };

  const confirm = () => {
    handleLogout();
  };

  

  const cancel: PopconfirmProps["onCancel"] = (e) => {};

  const items: MenuItem[] = [
    
    ...(user?.role === 'admin' || user?.role === 'controleur'
      ? [
        {
          label: <NavLink to="/">Dashboard</NavLink>,
          key: 'accueil',
          icon: <LuLayoutDashboard />,
        },
          {
            label: 'Projets',
            key: 'projets',
            icon: <BiBuildings /> ,
            children: [
              {
                label: <NavLink to="/projectsList">Liste des projets</NavLink>,
                key: 'projetsList',
                icon: <FaRegListAlt />,
              },
              {
                label: <NavLink to="/ajouterprojet">Créer un projet</NavLink>,
                key: 'ajouterprojet',
                icon: <CgFileAdd />,
              },
              // {
              //   label: <NavLink to="/affecterProjet">Affecter un projet</NavLink>,
              //   key: 'affecterProjet',
              //   icon: <MdOutlineAssignmentInd />,
              // },
            ],
          },
        ]
      : []),
    ...(user?.role === 'admin' || user?.role === 'controleur' || user?.role === 'visiteur'
      ? [
          {
            label: 'Visites',
            key: 'visites',
            icon: <TbHomeSearch/> ,
            children: [
              {
                label: <NavLink to="/lancerVisite">Lancer une visite</NavLink>,
                key: 'lancerVisite',
                icon: <VscDebugStart />,
              },
            ],
          },
        ]
      : []),
    ...(user?.role === 'admin'
      ? [
          {
            label: <NavLink to="/users">Gestion des utilisateurs</NavLink>,
            key: 'users',
            icon: <FiUsers />,
          },
        ]
      : []),
  ];

  const mobileMenu = (
    <Drawer
      
      placement="left"
      onClose={() => setDrawerVisible(false)}
      open={drawerVisible}
      style={{height:"100dvh"}}
    >
        <div style={{ height:"100%",display:"flex",flexDirection:"column",alignItems:"start",justifyContent:"space-between" }}>
        <Menu
        onClick={onClick}
        selectedKeys={[current]}
        mode="inline"
        items={items}
        style={{borderRight:"none"}}
      />
      <div style={{ width: '100%', display: 'flex', flexDirection: 'column', alignItems: 'end' }}>
        <Tag
          icon={<UserOutlined />}
          color="default"
          style={{
            marginRight: 0,}}
        >
          {user?.prenom + " " + user?.nom + " (" + user?.role + ")"}
        </Tag>
        <Popconfirm
          title="Attention : Toutes les données non sauvegardées seront perdues après la déconnexion."
          placement="bottom"
          onConfirm={confirm}
          onCancel={cancel}
          okText="Oui"
          cancelText="Non"
          icon={<QuestionCircleOutlined style={{ color: "red" }} />}
        >
          <Button variant="filled" color="danger" size="middle" style={{ marginTop: '10px' }}>
            Se déconnecter <LogoutOutlined />
          </Button>
        </Popconfirm>
      </div>
        </div>
      
    </Drawer>
  );

  return (
    <Row justify="space-between" style={{ width: '100%', paddingBottom: '10px', alignItems: 'center' }}>
      {isMobile ? (
        <>
          <Button style={{ marginLeft: '10px',marginTop:"10px" }} icon={<MenuOutlined />} onClick={() => setDrawerVisible(true)} />
          {mobileMenu}
        </>
      ) : (
        <div style={{ borderBottom: '1px solid #d9d9d9',width: '100%',display:"flex",alignItems:"center",justifyContent:"space-between",padding:0,marginBottom:"20px" }}>
          <S.CustomMenu
            style={{ flex: 1, borderBottom: 'none' }}
            triggerSubMenuAction="hover"
            onClick={onClick}
            selectedKeys={[current]}
            mode="horizontal"
            items={items}
          />
          <div style={{ display: 'flex', alignItems: 'center',paddingRight: '10px' }}>
            <Tag
              style={{  marginRight: '5px' }}
              icon={<UserOutlined />}
              color="default"
              
            >
              {user?.prenom + " " + user?.nom + " (" + user?.role + ") "}
            </Tag>
            <Popconfirm
              title="Attention : Toutes les données non sauvegardées seront perdues après la déconnexion."
              placement="bottomLeft"
              onConfirm={confirm}
              onCancel={cancel}
              okText="Oui"
              cancelText="Non"
              icon={<QuestionCircleOutlined style={{ color: 'red' }} />}
            >
              <Button variant="solid" color="danger" size="small">
                Se déconnecter <LogoutOutlined />
              </Button>
            </Popconfirm>
          </div>
        </div>
      )}
    </Row>
  );
};

export default NavMenu;
